import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function Users() {

  const token = localStorage.getItem("adminToken");

  const [users, setUsers] = useState([]);

  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);

  const [pages, setPages] = useState(1);

  useEffect(() => {

    loadUsers();

  }, [page]);

  async function loadUsers() {

    try {

      const res = await fetch(

        "/api/admin/users-list?page=" + page,

        {

          headers: {

            Authorization: "Bearer " + token

          }

        }

      );

      const json = await res.json();

      if (json.success) {

        setUsers(json.users);

        setPages(json.totalPages);

      }

    } catch (err) {

      console.log(err);

    }

  }

  async function searchUser() {

    if (!search) {

      loadUsers();

      return;

    }

    const res = await fetch(

      "/api/admin/search/" + search,

      {

        headers: {

          Authorization: "Bearer " + token

        }

      }

    );

    const json = await res.json();

    if (json.success) {

      setUsers(json.users);

    }

  }

  async function blockUser(userId) {

    await fetch("/api/admin/block", {

      method: "POST",

      headers: {

        "Content-Type": "application/json",

        Authorization: "Bearer " + token

      },

      body: JSON.stringify({

        userId

      })

    });

    loadUsers();

  }


  return (

    <div
      style={{
        display: "flex",
        background: "#f3f4f6",
        minHeight: "100vh"
      }}
    >

      <Sidebar />

      <div
        style={{
          flex: 1
        }}
      >

        <Header />

        <div
          style={{
            padding: 25
          }}
        >

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 20
            }}
          >

            <h2>All Users</h2>

            <div>

              <input

                value={search}

                onChange={(e) =>
                  setSearch(e.target.value)
                }

                placeholder="Search User"

                style={{
                  padding: 10,
                  width: 250
                }}

              />

              <button

                onClick={searchUser}

                style={{
                  marginLeft: 10,
                  padding: "10px 20px",
                  background: "#2563eb",
                  color: "#fff",
                  border: 0,
                  cursor: "pointer"
                }}

              >

                Search

              </button>

            </div>

          </div>

          <table

            width="100%"

            cellPadding="10"

            style={{
              background: "#fff",
              borderCollapse: "collapse"
            }}

          >

            <thead>

              <tr
                style={{
                  background: "#2563eb",
                  color: "#fff"
                }}
              >

                <th>User ID</th>

                <th>Email</th>

                <th>Sponsor</th>

                <th>Wallet</th>

                <th>Status</th>

                <th>Action</th>

              </tr>

            </thead>

            <tbody>

              {
                users.map((u) => (

                  <tr key={u._id}>


                    <td>{u.userId}</td>

                    <td>{u.email}</td>

                    <td>{u.sponsorId}</td>

                    <td>

                      {Number(
                        u.walletBalance || 0
                      ).toFixed(2)}

                    </td>

                    <td>

                      {u.blocked ? (

                        <span
                          style={{
                            color: "red",
                            fontWeight: "bold"
                          }}
                        >
                          Blocked
                        </span>

                      ) : (

                        <span
                          style={{
                            color: "green",
                            fontWeight: "bold"
                          }}
                        >
                          Active
                        </span>

                      )}

                    </td>

                    <td>

                      <button

                        onClick={() =>
                          blockUser(u.userId)
                        }

                        style={{
                          padding: "6px 12px",
                          background: u.blocked
                            ? "#16a34a"
                            : "#dc2626",
                          color: "#fff",
                          border: 0,
                          borderRadius: 4,
                          cursor: "pointer"
                        }}

                      >

                        {u.blocked
                          ? "Unblock"
                          : "Block"}

                      </button>

                    </td>

                  </tr>

                ))
              }

            </tbody>

          </table>

          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "center",
              gap: 10
            }}
          >

            <button

              disabled={page === 1}

              onClick={() =>
                setPage(page - 1)
              }

            >

              Previous

            </button>

            <span>

              Page {page} of {pages}

            </span>

            <button

              disabled={page === pages}

              onClick={() =>
                setPage(page + 1)
              }

            >

              Next

            </button>

          </div>

        </div>

      </div>

    </div>

  );

}
